import Adjust from '@adjustcom/adjust-web-sdk';
import CONST from '@/config/const';
import { apiHost } from '@/config/setup';
import { userApi } from '@/config/api';

export default () => {

  // 获取点击ID
  const getParameterByName = (name: string, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return encodeURIComponent(decodeURIComponent(results[2].replace(/\+/g, ' ')));
  };

  // 初始化adjust
  const initAdjust = () => {
    Adjust.initSdk({
      appToken: CONST.adjust.appToken,
      environment: apiHost.adjust,
      logLevel: apiHost.adjust === 'sandbox' ? 'verbose' : 'none'
    });
  };

  // setReferrer
  const setReferrer = () => {
    const clickId = getParameterByName('adjust_external_click_id');
    console.log('clickId', clickId);
    if (clickId) {
      // 初始化adjust
      initAdjust();
      // 设置referrer
      Adjust.setReferrer(clickId);
    }
  };

  // adjust上报
  const bindUserAdjustId = async() => {
    // 上报数据
    Adjust.waitForWebUUID().then((uuid: string) => {
      // 上报事件
      Adjust.trackEvent({
        eventToken: CONST.adjust.event1Token
      });

      // 上报中台
      userApi.bindUserAdjustId({
        webuuid: uuid
      });
    });
  };

  return {
    initAdjust,
    setReferrer,
    bindUserAdjustId
  };
};